/**
 * Urban airship docs:
 * https://docs.airship.com/reference/libraries/web-notify-sdk/latest/index.html
 */
import { NOTIFICATION_GROUPS } from 'tradera-constants/push-notifications';
import logger from 'packages/logger';
import { localStore } from 'utils/storage';
import { STORAGE_KEYS } from 'constants/storage';

/**
 * get the urban airship sdk.
 * @returns obj if null then no sdk object available
 */
export const getSdk = () => {
    return new Promise(resolve => {
        if (!window.UA) {
            return resolve(null);
        }
        if (window.UACache) {
            return resolve(window.UACache);
        }

        UA.then(sdk => {
            window.UACache = sdk;
            return resolve(window.UACache);
        }).catch(() => {
            // browser is most likely not supported, return null
            window.UACache = null;
            return resolve(null);
        });
    });
};

export const enableWebPush = async memberId => {
    try {
        const sdk = await getSdk();
        if (sdk === null) return;
        const channel = await sdk.register();
        await channel.namedUser.set(memberId.toString());

        // register to all channels
        for (let tags of Object.values(NOTIFICATION_GROUPS)) {
            for (let t of tags) {
                await channel.tags.add(t);
            }
        }
    } catch (error) {
        logger(error);
    }
};

/**
 * opt out from notifications when doing a logout
 */
export const disableWebPush = async () => {
    try {
        const sdk = await getSdk();
        if (sdk !== null && sdk.isSupported && sdk.channel != null) {
            await sdk.channel.optOut();
        }
    } catch (error) {
        logger(error);
    }
};

export const rememberPushNotificationSetting = async () => {
    let accepted = 'no';
    try {
        const sdk = await getSdk();
        if (!(sdk === null || sdk.channel === null)) {
            accepted = sdk.channel.optedIn ? 'yes' : 'no';
        }
    } catch (error) {
        logger(error);
    }
    localStore.setItem(STORAGE_KEYS.WEB_PUSH_ACCEPTED, accepted);
};
